import { render, staticRenderFns } from "./PackageCourse.vue?vue&type=template&id=1aa817e1&scoped=true&"
import script from "./PackageCourse.vue?vue&type=script&lang=js&"
export * from "./PackageCourse.vue?vue&type=script&lang=js&"
import style0 from "./PackageCourse.vue?vue&type=style&index=0&id=1aa817e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa817e1",
  null
  
)

export default component.exports